import React from 'react';
import styled from 'styled-components';

import MagnifyingGlass from '@zocdoc-frontend-common/assets-icons/MagnifyingGlass';
import { CompactModal as Modal } from '@zocdoc-mezzanine/components-modal';

import { noop } from 'lodash';
import ModalBody from './ModalBody';

export default function MentalHealthOONModal(props) {
    const {
        onClickContinue,
        beforeClickFindInNetworkDoctors,
        findDoctorsUrl,
        providerName,
        providerPictureUrl,
        selfPaySettings,
        sendMetric = noop,
        onClickCancel,
        onClose,
        ...otherProps
    } = props;

    return (
        <Modal
            aria-describedby="mh-oon-modal-description"
            data-test="mh-oon-modal"
            title={`${providerName} is out-of-network`}
            primaryButtonProps={{
                children: 'Continue',
                onClick: onClickContinue,
            }}
            secondaryButtonProps={{
                children: (
                    <>
                        <StyledMagnifyingGlass color="currentColor" />
                        Find in-network doctors
                    </>
                ),
                href: findDoctorsUrl,
                beforeClick: beforeClickFindInNetworkDoctors,
            }}
            onClose={onClose || onClickCancel}
            {...otherProps}
        >
            <ModalBody
                selfPaySettings={selfPaySettings}
                sendMetric={sendMetric}
            />
        </Modal>
    );
}

const StyledMagnifyingGlass = styled(MagnifyingGlass)`
    font-size: 17px;
    margin-right: 7px;
    position: relative;
    top: 2px;
`;
